import {TransportMethod, StatisticsGroupWrapper, StatisticsType, TransportCategory} from "@ots-frontend/ots-data";
import {PropsWithChildren, useMemo} from "react";
import {InsightPieChart, InsightPieChartProps} from "../InsightPieChart/InsightPieChart";
import {PieChartData} from "../../chart/PieChart/PieChart";
import {InsightEmpty} from "../InsightEmpty/InsightEmpty";

export type ByInsightProps = Pick<InsightPieChartProps, 'tooltipPos' | 'containerProps' | 'loading' | 'id' | 'mih'> & {
  title: string
  data?: StatisticsGroupWrapper[],
  method?: TransportMethod
  statisticsType: StatisticsType
  category?: TransportCategory,
  showEmpty?: boolean
}

export const ByInsight = (props: PropsWithChildren<ByInsightProps>) => {
  const {
    title,
    data,
    method,
    statisticsType,
    category,
    showEmpty = true,
    children,
    ...rest
  } = props

  const chartData: PieChartData[] | undefined = useMemo(() => {
    const chartData: PieChartData[] = []

    data?.forEach((stat) => {
      const value = stat.getValue(method, statisticsType, undefined, category)
      if (value > 0) {
        chartData.push({
          name: stat.name,
          value: value
        })
      }
    })

    return chartData
  }, [data, method, statisticsType, category])

  if (showEmpty && (!chartData || chartData.length === 0)) {
    return (
      <InsightEmpty {...rest} title={title}>
        {children}
      </InsightEmpty>
    )
  }

  return (
    <InsightPieChart
      {...rest}
      title={title}
      data={chartData}>
      {children}
    </InsightPieChart>
  )
}
